// extracted by mini-css-extract-plugin
module.exports = {"shareModalContainer":"ShareButton_shareModalContainer__2MQiv","copyTextContent":"ShareButton_copyTextContent__15C3s"};